/**
 * The one name-matching rule (moved from the Clients page so the top
 * search finds exactly what the roster finds): the query trimmed and
 * lower-cased, and a row matches when the query is a substring of any one
 * of its fields, each field tested on its own (a query spanning two fields
 * matches neither). An empty query matches every row.
 *
 * Used by src/pages/Clients.tsx (the roster and the SPICE view) and by
 * the top search (src/components/GlobalSearch.tsx). Each caller decides
 * which fields a row offers.
 */

/** The search as matched: trimmed and lower-cased. */
export function searchQuery(search: string): string {
  return search.trim().toLowerCase();
}

/** True when the query (already through searchQuery) is a substring of
 *  any one field. */
export function matchesSearch(query: string, fields: readonly (string | null)[]): boolean {
  if (query === '') return true;
  return fields.some((f) => f !== null && f.toLowerCase().includes(query));
}
